import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { ConfiguracionService } from '../../../services/configuracion.service';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-upload-imagen',
    templateUrl: './upload-imagen.component.html'
})
export class UploadImagenComponent implements OnInit {

    private _imagen;

    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();

    public filePath: string;

    public showForm = false;

    public dragAreaClass: string;

    @Input() disenyoEtiquetaId;
    @Input() filename?;
    @Input() imagen?;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() refreshReferencia = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();


    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _dataProvider: DataProvider,
        private readonly _spinnerService: SpinnerService,
        private readonly _configuracionService: ConfiguracionService,
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            archivo: [[{ value: '', disabled: true }], Validators.required],
            refArchivo: [[{ value: '', disabled: true }], Validators.required]
        });
        this.dragAreaClass = 'dragarea';
    }

    @HostListener('dragover', ['$event']) onDragOver(event: any) {
        this.dragAreaClass = 'droparea';
        event.preventDefault();
    }
    @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
        this.dragAreaClass = 'droparea';
        event.preventDefault();
    }
    @HostListener('dragend', ['$event']) onDragEnd(event: any) {
        this.dragAreaClass = 'dragarea';
        event.preventDefault();
    }
    @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
        this.dragAreaClass = 'dragarea';
        event.preventDefault();
    }
    @HostListener('drop', ['$event']) onDrop(event: any) {
        this.dragAreaClass = 'dragarea';
        event.preventDefault();
        event.stopPropagation();
        this.filePath = event.target.value;
        if (event.dataTransfer.files) {
            let files: FileList = event.dataTransfer.files;
            this.saveFiles(files);
        }
    }

    public saveFiles(files: FileList) {
        if (files.length > 1) {
            this.mensajes.push({ class: 'error', message: 'Solo se permite seleccionar un archivo' });
        } else {
            this.convertToBase64(files[0]);
        }
    }

    public onFileChange(event: any) {
        let files: FileList = event.target.files;
        this.saveFiles(files);
    }

    public convertToBase64(file) {
        if (file.type === 'image/jpeg' || file.type === 'image/jpg') {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            this._spinnerService.showSpinner();
            reader.onload = () => {
                this._spinnerService.hideSpinner();
                this.showForm = true;
                this.newEditForm.patchValue({
                    archivo: reader.result.toString().replace('data:image/jpeg;base64,', ''),
                    refArchivo: file.name
                });
            };
        } else {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'Seleccione una imagen con formato .jpg o .jpeg' });
        }
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid) {
            this._imagen = {
                id: this.disenyoEtiquetaId,
                archivo: this.newEditForm.get('archivo').value,
                refArchivo: this.newEditForm.get('refArchivo').value
            };
            this._spinnerService.showSpinner();
            this._configuracionService.asociarDisenyoEtiqueta(this._imagen).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.refreshReferencia.emit(true);
                this.showError = true;
                this.mensajes.push({ class: 'success', message: 'Imagen Asociada Correctamente' });
            },
                (error) => {
                    this.showError = true;
                    this.mensaje.emit('global.error.noResponse');
                });
        }
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._configuracionService.deleteRefereciaDisenyoEtiqueta(this.disenyoEtiquetaId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.refreshReferencia.emit(false);
            this.showError = true;
            this.mensajes.push({ class: 'success', message: 'Imagen Eliminada Correctamente' });
            this.imagen = null;
            this.newEditForm.reset();
            this.showForm = false;
        },
            (error) => {
                this.showError = true;
                this.mensaje.emit('global.error.noResponse');
            });
    }

    public download() {
        let byteString = window.atob(this.imagen.replace('data:image/jpeg;base64,', ''));
        let arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
        let int8Array: Uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'image/jpeg' });
        saveAs(blob, this.filename);
    }

    public close() {
        this.refresh.emit(false);
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

}
